export default __webpack_public_path__ + "assets/bb93a6edc21db75e9fbe6150035ad064.svg";